import { render, staticRenderFns } from "./listDetail.vue?vue&type=template&id=0c72ef08&scoped=true"
import script from "./listDetail.vue?vue&type=script&lang=js"
export * from "./listDetail.vue?vue&type=script&lang=js"
import style0 from "./listDetail.vue?vue&type=style&index=0&id=0c72ef08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72ef08",
  null
  
)

export default component.exports